import cx from 'classnames'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import {
  isValidDistributorForInAppDonations,
  platformStoreGet,
} from '../../../../../shared/helpers'
import { isDonationActiveOrPastDue } from '../../../actions/tvaultActions'
import { useAppSelector } from '../../../hooks/useStore'
import { donationFeatureEnabled } from './utils'

import FocusableButtonTS from '../../FocusableButton/FocusableButtonTS'
import { PassportIcon } from '../../Icons'
import { ButtonProps } from '../types'
import { ContentActionButtonFocusKeys, ContentActionButtonLabel } from './types'

function Passport(props: ButtonProps) {
  const [isFocused, setIsFocused] = useState(false)
  const { user, videoDetails, device, station } = useAppSelector((state) => ({
    user: state.user,
    videoDetails: state.content.videoDetails,
    device: state.device,
    station: state.station,
  }))

  const params = useParams()
  const navigate = useNavigate()

  const [loadingDonationStatus, setLoadingDonationStatus] = useState(false)
  const [isActiveOrPastDueDonation, setIsActiveOrPastDueDonation] =
    useState(false)
  const [canDonate, setCanDonate] = useState(false)

  const stationHasDonationCampaign =
    station.donation_campaign.station_has_donation_campaign

  const deviceAvailableToDonate = isValidDistributorForInAppDonations(
    device.distributor
  )

  const donationUrl = `/in-app-donations${device.donationQueryParams ?? ''}`
  const passportUpsellUrl = `/passport-upsell/${station.call_sign}?video=${params.url}`

  const contentIsMVOD = videoDetails.is_mvod
  const isContentPlayable = videoDetails.isPlayable || user.ignoreIsPlayable
  const isPlayableExplanation = videoDetails.isPlayableExplanation

  const fetchActiveOrPastDueDonation = async () => {
    try {
      setLoadingDonationStatus(true)
      const isActiveOrPastDue = await isDonationActiveOrPastDue()
      setIsActiveOrPastDueDonation(isActiveOrPastDue)
    } catch (error) {
      console.error('Error fetching donation status:', error)
      return false
    } finally {
      setLoadingDonationStatus(false)
    }
  }

  useEffect(() => {
    donationFeatureEnabled && fetchActiveOrPastDueDonation()
  }, [])

  useEffect(() => {
    if (!loadingDonationStatus && donationFeatureEnabled) {
      setCanDonate(
        stationHasDonationCampaign &&
          deviceAvailableToDonate &&
          !isActiveOrPastDueDonation
      )
    }
  }, [loadingDonationStatus, isActiveOrPastDueDonation])

  const unactivatedPassport = platformStoreGet('mvault_id')

  const shouldShowPassportUpsellButton =
    !isContentPlayable &&
    isPlayableExplanation &&
    isPlayableExplanation.includes('mvod_logic')

  const canCreateButton =
    shouldShowPassportUpsellButton &&
    (!user.validPassport || contentIsMVOD) &&
    !unactivatedPassport

  let onPressAction: () => void = () => {}
  if (canCreateButton) {
    if (canDonate) {
      onPressAction = () => navigate(donationUrl)
    } else {
      onPressAction = () => navigate(passportUpsellUrl)
    }

    props.onPress(ContentActionButtonLabel.PASSPORT)
  }

  const onFocus = () => {
    setIsFocused(true)
    props.onFocus({
      label: ContentActionButtonLabel.PASSPORT,
    })
  }

  const onBlur = () => {
    setIsFocused(false)
  }

  if (!canCreateButton) {
    return <></>
  }
  return (
    <div className="video-detail-screen__control-button">
      <FocusableButtonTS
        focusKey={ContentActionButtonFocusKeys.PASSPORT}
        onEnterPress={onPressAction}
        onArrowPress={props.onArrowPress}
        className="passport-button"
        onFocus={onFocus}
        onBlur={onBlur}
        stealFocus={true}
      >
        <PassportIcon />
      </FocusableButtonTS>
      <span
        className={cx('video-detail-screen__control-button-label', {
          'video-detail-screen__control-button-label--focused': isFocused,
        })}
      >
        {ContentActionButtonLabel.PASSPORT}
      </span>
    </div>
  )
}

export default Passport
